export * from './PageDirectionButtons'
export * from './PaginationCounter'
export * from './PaginationDetails'
export * from './Pagination'
import Pagination from './Pagination'

export default Pagination
